import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/login";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/login")({
  head: () => buildNoindexHead("Sign In", "/login"),
  component: Page,
});
